import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { MasterMedicine } from '../../../apis/master-medicines/types';
import { StyledPaperContainer } from '../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { StyledButtonsContainer } from '../../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import CreateSaveMasterMedicineButton from './Buttons/CreateSaveMasterMedicineButton';
import DeleteMasterMedicine from './Buttons/DeleteMasterMedicine';

interface MasterMedicineFooterProps {
  id?: string;
  form: UseFormReturn<MasterMedicine>;
}

export const MasterMedicineFooter = ({ form, id }: MasterMedicineFooterProps) => {
  return (
    <StyledPaperContainer>
      <StyledButtonsContainer>
        {id && <DeleteMasterMedicine id={id} />}
        <CreateSaveMasterMedicineButton id={id} form={form} />
      </StyledButtonsContainer>
    </StyledPaperContainer>
  );
};
